/**
 * Rounds a value to the nearest multiple of a given interval.
 * @example
 * roundToInterval(310, 300) // 300
 * roundToInterval(450, 300) // 600
 * @param {number} value - The value to round.
 * @param {number} roundInterval - The interval to round to.
 * @returns {number} The nearest multiple of `roundInterval`.
 */
export function roundToInterval(value, roundInterval) {
    
    if (roundInterval == 0)
        throw Error("roundInterval must be non-zero.");

    return Math.round(value / roundInterval) * roundInterval;
}

/**
 * Rounds a value down to the nearest multiple of a given interval.
 *
 * @param {number} value - The value to floor.
 * @param {number} floorInterval - The interval to floor to. Must be greater than 0.
 * @returns {number} The largest multiple of `floorInterval` that is less than or equal to `value`.
 *
 * @example
 * floorToInterval(137, 15); // 135
 * floorToInterval(120, 15); // 120
 */
export function floorToInterval(value, floorInterval) {

    if (floorInterval == 0)
        throw Error("floorInterval must be non-zero.");

    return Math.floor(value / floorInterval) * floorInterval;
}
/**
 * Returns a random integer between min and max (inclusive).
 */
export function getRandomInt(min, max) {
    return Math.floor(
        Math.random() * (max - min + 1)
    ) + min;
}


// WEBPACK FOOTER //
// ./src/helpers/math.js